import './INVC.scss';
import '../../helpers/print.scss';
import {PageManager} from 'genesis-packages/core';
import EmailInvoice from '../../extensions/checkout/EmailInvoice';

export default class INVC extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		new EmailInvoice();

		/**
		 *  Launch Printer Dialog
		 */
		const printTriggers = document.getElementsByClassName('js-print-invoice');

		if (printTriggers.length) {
			for (let element of printTriggers) {
				element.addEventListener('click', function (e) {
					e.preventDefault();
					window.print();
				}, false);
			}
		}

	}

};
